import $ from 'jquery';

$(document).ready(function() {

  // Because DataTables removes non-visible elements from the DOM
  // Destroy the DataTable instance upon form submission 
  // This ensures all inputs (even non-visible ones) are included in the posted data
  var wrapper = '#admin_manage_nominees_wrapper'
  $(wrapper).find('.form_submit_status').hide();

  $(wrapper).on("click change", ".submit_btn", function(event) {
    $(wrapper).find('.form_submit_status').show();
    $(wrapper).find('.actions').hide();
    $(wrapper).find('table').fadeOut();
    $('#datatable_manage_nominees').DataTable().destroy();
  });

});
